import { FormControl } from '@axo/ui-core/components/form/FormControl';
import { ReactNode } from 'react';

export interface IInputWrapperUI {
  children?: ReactNode;
  htmlFor?: string;
  labelId?: string;
  label?: string;
}

export const InputWrapperUI = ({
  children,
  htmlFor,
  labelId,
  label,
}: IInputWrapperUI) => {
  return (
    <>
      <FormControl.Label id={labelId} htmlFor={htmlFor}>
        {label}
      </FormControl.Label>
      {children}
    </>
  );
};

export default InputWrapperUI;
